import {useMemo, useState} from 'react';
import {AdditionalField} from './AdditionalField.jsx';
import {useContactForm} from './ContactFormContext';
import {Button, Icon, IconButton} from 'bonprix-design-system';

export function GroupOfMultipleEntries({fieldConfig, formErrors, cdaEntry}) {
    /**
     * articleNumber: ["1", "2"]
     * articleSize: ["a", "b"]
     */
    const {formValues, setFormValues} = useContactForm();

    const handleAddButtonClick = () => {
        setFormValues((prevValues) => {
            const individualFields = {};
            fieldConfig.fields.forEach((field) => {
                individualFields[field.name] = [...prevValues[field.name], ''];
            });

            return {
                ...prevValues,
                ...individualFields,
            };
        });
    };

    const handleRemoveButtonClick = (index) => () => {
        setFormValues((prevValues) => {
            const individualFields = {};
            fieldConfig.fields.forEach((field) => {
                individualFields[field.name] = prevValues[field.name].toSpliced(index, 1);
            });

            return {
                ...prevValues,
                ...individualFields,
            };
        });
    };

    const fields = formValues[fieldConfig.fields[0].name] || [''];

    const addButtonDisabled = useMemo(() => {
        const fieldFormValues = fieldConfig.fields.flatMap((field) => formValues[field.name] || []);
        const hasEmptyFields =  fieldFormValues.some((field) => field === '');

        if(fieldFormValues.length < fieldConfig.fields.length || hasEmptyFields) {
            return true;
        }

        if(fields.length >= 5) {
            return true;
        }

        return false;
    },[fields, formValues, fieldConfig.fields]);

    return (
        <div className="form-row">
            {fields.map((_, index) => (
                <div key={index} className="flex gap-2">
                    <div className="grow">
                        {fieldConfig.fields.map((field, indexField) => (
                            <AdditionalField
                                key={indexField}
                                formErrors={formErrors}
                                cdaEntry={cdaEntry}
                                additionalField={field}
                                index={index}
                            />
                        ))}
                    </div>
                    <div>
                        {index > 0 && (
                            <IconButton
                                icon="trash-bin"
                                label="Eintrag entfernen"
                                variant="secondary"
                                onClick={handleRemoveButtonClick(index)}
                            />
                        )}
                    </div>
                </div>
            ))}
            <div className="flex justify-end">
                <Button contentWidth onClick={handleAddButtonClick} disabled={addButtonDisabled}>
                    {fieldConfig.addButtonLabel}
                </Button>
            </div>
        </div>
    );
}
